import styles from './ButtonSendForm.module.css'
import { Button } from 'antd'

function ButtonSendForm({ style, text, onSubmit, disabled }) {
  return (
    <Button
      style={style}
      className={styles.buttonSubmit}
      onClick={onSubmit}
      type="submit"
      disabled={disabled}
    >
      {text || 'Envoyer'}
    </Button>
  )
}

export default ButtonSendForm
